import { render, staticRenderFns } from "./ListRecord.vue?vue&type=template&id=1b46ed65&scoped=true&"
import script from "./ListRecord.vue?vue&type=script&lang=js&"
export * from "./ListRecord.vue?vue&type=script&lang=js&"
import style0 from "./ListRecord.vue?vue&type=style&index=0&id=1b46ed65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46ed65",
  null
  
)

export default component.exports